var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message",class:{
    'company-message': _vm.sender.type === 'PayeeId',
    unseen: !_vm.seen,
  }},[_c('span',{staticClass:"sender-name"},[_vm._v(" "+_vm._s(_vm.senderName)+" ")]),_c('div',{staticClass:"text-secondary pull-right",staticStyle:{"font-size":"12px"}},[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.timestamp))+" ")]),_c('div',{staticClass:"content"},[_c('RichText',{staticStyle:{"white-space":"pre-line","width":"100%"},attrs:{"value":_vm.content}})],1),(!_vm.seen)?_c('div',{staticClass:"unseen-bouble"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }